let enGb = {
  translations: {
    organisation: 'Trust',
    organisations: 'Trusts',
  },
};

export default enGb;
